const PLUGIN_NAME = 'structured-data-fe';
const SOCIAL_META_IMAGE_KEY = 'socialMeta';
const IMAGE_URL_KEY = 'url';
const IMAGE_CONTENT_URL_KEY = 'contentUrl';
export { PLUGIN_NAME, SOCIAL_META_IMAGE_KEY, IMAGE_URL_KEY, IMAGE_CONTENT_URL_KEY };
//# sourceMappingURL=constants.js.map